import { Loader2 } from 'lucide-react';
import { cn } from '../utils/common';

export const Spinner = ({ className }: { className?: string }) => {
  return (
    <div className={cn(
      "w-full h-full flex justify-center items-center gap-3 text-neutral-light",
      className
    )}>
      <Loader2 size={28} className="animate-spin" />
      Loading...
    </div>
  );
};
